import {
  GET_ADAPTER_CONFIG_DETAILS,
  GET_ANALYTICS_CONFIG_DETAILS,
  LoadAdapterConfigAction,
  LoadAnalyticsConfigAction,
  RESET_ADAPTER_DETAILS,
  RESET_ANALYTICS_DETAILS,
} from "./AdapterConfigTypes";

export const fetchAdapterDetails = (): LoadAdapterConfigAction => {
  return {
    type: GET_ADAPTER_CONFIG_DETAILS,
  };
};

export const resetAdapterDetails = () => {
  return {
    type: RESET_ADAPTER_DETAILS,
  };
};

export const fetchAnalyticsConfig = (): LoadAnalyticsConfigAction => {
  return {
    type: GET_ANALYTICS_CONFIG_DETAILS,
  };
};

export const resetAnalyticAdaptersDetails = () => {
  return {
    type: RESET_ANALYTICS_DETAILS,
  };
};
